module.exports = __webpack_public_path__ + "img/blue-eye.e91f1153.svg";